export const RANGE_MINUTES = {
  '1m': 1,
  '5m': 5,
  '15m': 15,
  '1h': 60,
  '6h': 360,
  '24h': 1_440,
  '7d': 10_080,
  '30d': 43_200,
  '60d': 86_400,
} as const

export type RangeKey = keyof typeof RANGE_MINUTES | 'custom' | 'all'

export const getRangeOptions = (): { value: RangeKey; label: string }[] => {
  return [
    { value: 'all', label: getLabel('all') },
    ...Object.entries(RANGE_MINUTES).map(([key]) => ({
      value: key as RangeKey,
      label: getLabel(key as RangeKey),
    })),
    { value: 'custom', label: getLabel('custom') },
  ]
}

const getLabel = (key: RangeKey): string => {
  const labels: Record<RangeKey, string> = {
    '1m': 'Last 1 minute',
    '5m': 'Last 5 minutes',
    '15m': 'Last 15 minutes',
    '1h': 'Last hour',
    '6h': 'Last 6 hours',
    '24h': 'Last 24 hours',
    '7d': 'Last 7 days',
    '30d': 'Last 30 days',
    '60d': 'Last 60 days',
    custom: 'Custom range',
    all: 'All time',
  }
  return labels[key]
}
